import { Typography, Box, CircularProgress, Link } from "@mui/material";

import InfoCard from "./InfoCard";
export const bundesland = {
    BW: "Baden-Württemberg",
    BY: "Bayern",
    BE: "Berlin",
    BB: "Brandenburg",
    HB: "Bremen",
    HH: "Hamburg",
    HE: "Hessen",
    MV: "Mecklenburg-Vorpommern",
    NI: "Niedersachsen",
    NW: "Nordrhein-Westfalen",
    RP: "Rheinland-Pfalz",
    SL: "Saarland",
    SN: "Sachsen",
    ST: "Sachsen-Anhalt",
    SH: "Schleswig-Holstein",
    TH: "Thüringen",
};

export const labels = {
    protectedAreas: {
        id: "DB Id",
        type: "Typ",
        name: "Name",
        bfn_id: "BfN Id",
        bundesland: "Bundesland",
        link: "Link",
        leg_titel: "Verordnung",
        leg_date: "Verordnungsdatum",
        flaeche: "Fläche",
    },
    glöz2: {
        id: "Id",
        bl: "Bundesland",
        genese: "Genese",
        decke: "Decke",
        torfmaecht: "Torfmächtigkeit",
        abmoorigke: "Abmoorigkeit",
        tiefumbruc: "Tiefumbruch",
        mudde: "Unterlagernde Mudde",
        unterlager: "Mineralisches Substrat",
        area_ha_r: "Area",
        kat_lang: "Moorbodenkategorie",
    },
    nut2: {
        anteil: "Anteil organischer Böden",
    },
};

const titelFields = {
    protectedAreas: "type",
    glöz2: "kat_lang",
    nut2: "nuts_name",
};

const formatValue = (key, value) => {
    if (value === null || String(value).length === 0) {
        return "Keine Information";
    }

    if (key === "bundesland") {
        return bundesland[value] || value;
    }

    if (key === "leg_date") {
        const datePart = String(value).split(" ")[0];
        const date = new Date(datePart);
        return isNaN(date)
            ? "Keine Information"
            : new Intl.DateTimeFormat("de-DE").format(date);
    }

    if (key === "link") {
        return (
            <Link href={value} target="_blank" underline="hover" rel="noopener">
                {value}
            </Link>
        );
    }
    if (key === "orgsoil" || key === "flaeche") {
        const formatNumber = (v) =>
            new Intl.NumberFormat("de-DE").format(Number(v));
        return formatNumber(value) + " ha";
    }
    if (key === "anteil") {
        const num = Number(value);
        if (isNaN(num)) return String(value);
        const formatNumber = (v) =>
            new Intl.NumberFormat("de-DE").format(Number(v));
        return formatNumber(num) + " %";
    }

    return String(value);
};

export default function ResultInfo({
    isLoading,
    matchingAreas,
    expanded,
    onChange,
    type,
}) {
    if (isLoading) {
        return (
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                    width: "100%",
                }}
            >
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <CircularProgress size="30px" />
                </Box>
            </Box>
        );
    }
    if (!Array.isArray(matchingAreas)) {
        return (
            <Box>
                <Typography variant="body2" color="white">
                    {matchingAreas}
                </Typography>
            </Box>
        );
    }
    return (
        <Box variant="body2">
            <Box
                sx={{
                    width: "270px",
                    marginLeft: "-20px",
                    mt: 2,
                }}
            >
                {matchingAreas.map((obj) => {
                    const isExpanded = expanded === obj.id;

                    return (
                        <InfoCard
                            onToggle={onChange}
                            formatValue={formatValue}
                            isExpanded={isExpanded}
                            labels={labels[type]}
                            obj={obj}
                            titelField={titelFields[type]}
                            type={type}
                        />
                    );
                })}
            </Box>
        </Box>
    );
}
